// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".markdown ol,.markdown ul{list-style:inherit;padding-left:1rem}.markdown li>ol,.markdown li>ul{padding-top:1rem}.markdown ol>li:not(:last-child),.markdown ul>li:not(:last-child){margin-bottom:1rem}.markdown a{--tw-text-opacity:1;color:#015642;color:rgba(1,86,66,var(--tw-text-opacity,1))}.markdown a:hover{-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
